import { useGuardianAlertNotifications } from "./hooks/useGuardianAlertNotifications";

/** Global listener for Guardians screening alert toasts (mounted at app shell). */
export function GuardiansAlertNotificationListener() {
  useGuardianAlertNotifications();
  return null;
}
